import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
	selector: "app-unsaved-confirmation",
	templateUrl: "./unsaved-confirmation.component.html",
	styleUrls: ["./unsaved-confirmation.component.scss"],
})
export class UnsavedConfirmationDialog implements OnInit {

	constructor(
		public dialogRef: MatDialogRef<UnsavedConfirmationDialog>,
		) {
	}

	ngOnInit() {}

	cancel() {
		this.dialogRef.close(false);
		return;
	}

	confirm() {
		this.dialogRef.close(true);
		return;
	}
}
